module.exports = __webpack_public_path__ + "img/13.717cc8fc.jpg";